import React from "react";
import AllThreeDModels from "../AllThreeDModels/App";

// icon
import { Icon } from "@iconify/react";

// gif
import car from "../../assets/gif/carnew.gif";

// svg
import wave from "../../assets/svg/wave.svg";

// css
import "./App.css";

const HomePage = () => {
  return (
    <div className="">
      <img
        src={wave}
        alt="wave"
        className=" waveSvg position-absolute top-0 w-100 h-100 "
      />
      <div className="container">
        <div className="row py-md-5  justify-content-center fullscreen align-items-center flex-wrap-reverse ">
          <div className="col-lg-6 col-md-8  home-banner-left">
            <p className="mb-0 welcomeTo">Welcome to , </p>
            <h1 className="mainTitle mb-3">
              <span className=""> 3D Showcase </span>{" "}
              <span className="horizontal_line"></span> <span> Models</span>
            </h1>
            <p>
              3D Showcase Models 3D Modelling is the process of using computer
              software to create 3D images of objects or areas. 3D artists
              manipulate points in the virtual environment known as vertices to
              form a mesh to create the object. A 3D model can be anything you
              may think of— whether you are in the business of selling consumer
              items, Automotives, Engineering Products or Real Eastate Using 3D
              modelling to their advantage sooner rather than later. Usage could
              that its speeds up the process of product design development,
              supports better product detailing, it is great for business
              branding, its fixes errors before final product design, offers
              efficiency and ease of use, it makes flaws easier to recognize, it
              encourages seamless collaboration &simplifies product prototyping
              and testing. Finally 3D Modelling lets you keep up with the market
              means.
            </p>
          </div>
          <div className="offset-lg-1 col-lg-5 col-md-12 home-banner-right">
            <img src={car} className="img-fluid car_gif " alt="car" />
            <div className="scrollDown_container">
              <div className="scrollDown">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="feature-area px-1 py-5 d-none">
        <div className="container-fluid">
          <div className="feature-inner justify-content-center justify-content-sm-start row g-3">
            <div className="col-lg-2 col-md-6 col-10">
              <div className="feature-item d-flex shadow-sm">
                <div className="p-2 border-end">
                  <Icon icon="akar-icons:book" />
                </div>
                <div className="ml-20 p-3 ">
                  <h5>New Classes</h5>
                  <p>
                    In the history of modern astronomy, there is probably no one
                    greater leap forward.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-10">
              <div className="feature-item d-flex shadow-sm ">
                <div className="p-2 border-end">
                  <Icon icon="akar-icons:trophy" />
                </div>
                <div className="ml-20 p-3 ">
                  <h5>Top Courses</h5>
                  <p>
                    In the history of modern astronomy, there is probably no one
                    greater leap forward.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-10">
              <div className="feature-item d-flex shadow-sm">
                <div className="p-2 border-end">
                  <Icon icon="mdi:monitor-screenshot" />
                </div>
                <div className="ml-20 p-3 ">
                  <h5>Full E-Books</h5>
                  <p>
                    In the history of modern astronomy, there is probably no one
                    greater leap forward.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* All product */}
      <AllThreeDModels />
    </div>
  );
};

export default HomePage;
